
import api from '@virgodev/bazaar/functions/api';
import { MenubarProps } from 'primevue/menubar';
import { defineComponent, ref, watch } from 'vue';
import { UserDataInterface } from '@/interfaces/users';
import { useStore } from '@/store';

export default defineComponent({
  setup() {
    const store = useStore();
    const appLaunchDataStatus = ref<'loading' | 'loaded' | 'error'>('loading');
    const menubarItems = ref<MenubarProps['model']>();

    function setMenubarItems() {
      if (store.loggedIn) {
        let usersLinkToName: string;

        if (store.userData.is_superuser) {
          usersLinkToName = 'companies';
        } else if (store.userData.group.group_type === 'admin') {
          usersLinkToName = 'admins_vendors_clients';
        } else if (store.userData.group.group_type === 'vendor') {
          usersLinkToName = 'vendor_users';
        } else if (store.userData.group.group_type === 'third_party_vendor') {
          usersLinkToName = 'third_party_vendor_users';
        } else {
          usersLinkToName = 'client_users';
        }

        menubarItems.value = [
          {
            label: 'Projects',
            to: { name: 'projects' },
          },
          {
            label: 'Users',
            to: { name: usersLinkToName },
            visible: () => store.userData.group.group_type === 'admin'
              || store.userData.can_manage_other_users,
          },
          {
            label: 'Third-Party Vendors',
            to: { name: 'third_party_vendors' },
            visible: () => store.userData.group.group_type === 'vendor',
          },
          {
            label: `${store.userData.first_name} ${store.userData.last_name}`,
            class: 'menuitem-account',
            items: [
              {
                label: 'Stop Impersonating',
                url: '/api/impersonate/stop/',
                visible: () => store.userData.is_impersonate,
              },
              {
                label: 'Change Password',
                to: { name: 'password_change' },
              },
              {
                label: 'Log Out',
                to: { name: 'logout' },
              },
            ],
          },
        ];
      } else {
        menubarItems.value = [
          {
            label: 'Log In',
            to: { name: 'login' },
          },
        ];
      }
    }

    async function loadAppLaunchData() {
      appLaunchDataStatus.value = 'loading';

      const responseData = await api({ url: 'app-launch/' });

      if (responseData.status === 200) {
        const responseBody: {
          // eslint-disable-next-line camelcase
          user_data?: UserDataInterface;
        } = responseData.body;

        if (responseBody.user_data !== undefined) {
          store.logIn(responseBody.user_data);
        }

        setMenubarItems();
        watch(() => store.userData, setMenubarItems);

        const appDiv = document.getElementById('app') as HTMLDivElement;
        appDiv.classList.remove('app-not-launched-content');

        appDiv.addEventListener('mousedown', (e) => {
          window.appEventBus.emit('appDivMouseDown', e);
        }, true);

        appLaunchDataStatus.value = 'loaded';
      } else {
        appLaunchDataStatus.value = 'error';
      }
    }

    loadAppLaunchData();

    return {
      appLaunchDataStatus,
      loadAppLaunchData,
      menubarItems,
    };
  },
});
